<sh-viewer [blobUrl]="blobUrl$ | async" [originalSourceUrl]="originalSourceUrl$ | async" [extension]="extension$ | async" [toastId]="toastId"></sh-viewer>
